import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { SkeletonPageHeader, SkeletonList } from '../Skeleton';

const RequireSuperAdmin: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();

  // Still hydrating
  if (user === null) {
    const stored = localStorage.getItem('user');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (parsed?.role === 'SUPER_ADMIN') {
          return <>{children}</>;
        }
        if (parsed?.role) {
          return <Navigate to="/dashboard" replace />;
        }
      } catch {
        /* fall through */
      }
    }
    return (
      <div className="p-8 max-w-3xl mx-auto space-y-4">
        <SkeletonPageHeader />
        <SkeletonList count={4} />
      </div>
    );
  }

  if (user.role !== 'SUPER_ADMIN' && !user.impersonating) {
    return <Navigate to="/dashboard" replace />;
  }

  // During impersonation, block /admin (exit first via banner)
  if (user.impersonating) {
    return <Navigate to="/dashboard" replace />;
  }

  if (user.role !== 'SUPER_ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default RequireSuperAdmin;
